import { Button, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="Доступ к странице запрещен"
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Перейти на главную страницу
        </Button>
      }
    />
  );
};

export default AccessDenied;
